import { GET_FACULTY_DATA } from 'volto-facultycv/constants/ActionTypes';
import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';

export default function get_faculty_data(url) {
  return {
    type: GET_FACULTY_DATA,
    request: {
      op: 'get',
      path: flattenToAppURL(`${url}/@search?portal_type=faculty2&metadata_fields=books&metadata_fields=articles&metadata_fields=chapters&metadata_fields=refereedProceedings&metadata_fields=nonRefereedProceedings&metadata_fields=monographs&metadata_fields=reviews&metadata_fields=presented&metadata_fields=patents&metadata_fields=professional&metadata_fields=grants&metadata_fields=officeHeld&metadata_fields=activities`),
    }
  };
}
